module.exports = "/packs/templates.dialog.product.quick_cart-21eec570.html";